import { merge } from 'lodash'

export default function (existingModel = {}) {
  return {
    model: merge(
      {
        name: null,
        email: null,
        value: 1500
      },
      existingModel
    ),
    validation: {
      name: { required: true },
      email: { required: true, email: true },
      value: { required: true, nonZeroValue: true, minValue: 1 }
    }
  }
}
